var map = {
	"./angular.svg": "9451",
	"./apple-safari.png": "4f49",
	"./book.svg": "a337",
	"./bootstrap.svg": "2ea3",
	"./brush.svg": "815f",
	"./doc.png": "493f",
	"./drive.png": "8f4a",
	"./dropbox.png": "0e4f",
	"./figma.svg": "7472",
	"./file-icons/doc.png": "61d5",
	"./file-icons/onedrive.png": "37bc",
	"./file-icons/pdf.png": "a235",
	"./file-icons/psd.png": "051b",
	"./file-icons/sketch.png": "2863",
	"./google-chrome.png": "d8dc",
	"./icloud-1.png": "e4ab",
	"./icloud.png": "9431",
	"./internet-explorer.png": "d7bc",
	"./internet.png": "beef",
	"./jpg.png": "1568",
	"./js.png": "2710",
	"./json.png": "0ec4",
	"./mozila-firefox.png": "9fa4",
	"./onedrive.png": "8250",
	"./onedrivenew.png": "efb5",
	"./opera.png": "2fad",
	"./parachute.svg": "666b",
	"./pdf.png": "f35f",
	"./people-fill.svg": "4cf7",
	"./psd.png": "3a95",
	"./react.svg": "f4d6",
	"./rocket.svg": "df02",
	"./sketch.png": "c62d",
	"./speaker.svg": "1535",
	"./star.svg": "0a83",
	"./toolbox.svg": "40d5",
	"./txt.png": "d36d",
	"./unknown.png": "91ed",
	"./video.png": "926b",
	"./vuejs.svg": "57c1",
	"./xls.png": "d75a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";